import React from 'react';
import Sym from './Sym';

/**
 * Botón del rediseño.
 *
 * @param {'primary'|'outline'|'ghost'|'danger'} variant
 * @param {'md'|'sm'} size
 * @param {string} icon      nombre de Material Symbol a la izquierda
 * @param {string} iconRight nombre de Material Symbol a la derecha
 * @param {boolean} loading  muestra spinner y deshabilita
 */
const Button = ({
  variant = 'primary',
  size = 'md',
  icon,
  iconRight,
  loading = false,
  disabled = false,
  className = '',
  children,
  ...rest
}) => (
  <button
    className={[
      'a2-btn', `a2-btn--${variant}`, size === 'sm' ? 'a2-btn--sm' : '', className,
    ].filter(Boolean).join(' ')}
    disabled={disabled || loading}
    {...rest}
  >
    {loading ? (
      <span className="a2-spinner" style={{ width: 16, height: 16 }} />
    ) : icon ? (
      <Sym name={icon} size={size === 'sm' ? 17 : 20} />
    ) : null}
    {children}
    {iconRight && !loading ? <Sym name={iconRight} size={size === 'sm' ? 17 : 18} /> : null}
  </button>
);

/**
 * Botón cuadrado de solo icono (acciones de fila: reset de contraseña, eliminar,
 * descargar un recibo…). Admite `loading` como el botón normal: sin esto, la
 * prop se colaba al DOM ("Received `false` for a non-boolean attribute") y las
 * descargas no daban señal de estar en curso.
 */
export const IconButton = ({
  icon, tone = 'default', loading = false, disabled = false, className = '', ...rest
}) => (
  <button
    className={[
      'a2-btn', 'a2-btn--icon', tone === 'danger' ? 'a2-btn--icon-danger' : '', className,
    ].filter(Boolean).join(' ')}
    disabled={disabled || loading}
    {...rest}
  >
    {loading
      ? <span className="a2-spinner" style={{ width: 16, height: 16 }} />
      : <Sym name={icon} size={18} />}
  </button>
);

export default Button;
